import {
  Button,
  DialogActions,
  DialogActionsProps,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Dialog as MuiDialog,
} from '@mui/material';
import React, { ReactElement } from 'react';

export interface DialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm?: () => Promise<void>;
  title: string;
  content?: string | ReactElement | null;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  actionsProps?: DialogActionsProps;
}

const Dialog: React.FC<DialogProps> = ({
  open,
  onConfirm,
  onCancel,
  title,
  content = null,
  confirmText,
  cancelText,
  isLoading = false,
  actionsProps,
}) => {
  const cancelButtonVisible = !!(cancelText && onCancel);
  const confirmButtonVisible = !!(confirmText && onConfirm);

  return (
    <MuiDialog open={open} onClose={onCancel} fullWidth maxWidth='sm'>
      <DialogTitle sx={{ px: 0, textAlign: 'center' }}>{title}</DialogTitle>
      {content && typeof content === 'string' ? (
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
      ) : (
        content
      )}
      {(cancelButtonVisible || confirmButtonVisible) && (
        <DialogActions {...actionsProps}>
          {cancelButtonVisible && (
            <Button onClick={onCancel} color='secondary'>
              {cancelText}
            </Button>
          )}
          {confirmButtonVisible && (
            <Button onClick={onConfirm} loading={isLoading} color='primary' variant='contained'>
              {confirmText}
            </Button>
          )}
        </DialogActions>
      )}
    </MuiDialog>
  );
};

export default Dialog;
